import * as tslib_1 from "tslib";
import * as preferences from '../actions/preferences.actions';
var initialState = {
    tenantViewType: null,
    viewType: null,
    viewTypeAdjustable: true,
    fullWidthView: false,
    tenantSettings: null,
    quantityPicker: 'absolute',
    appName: null,
    tenantCode: null,
    topMenuStyle: null,
    catalogSortOrders: null,
    error: null
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case preferences.SET_VIEW_TYPE:
            return tslib_1.__assign({}, state, { viewType: action.payload });
        case preferences.SET_FULL_WIDTH_VIEW:
            return tslib_1.__assign({}, state, { fullWidthView: action.payload });
        case preferences.GET_TENANT_SETTINGS:
            return tslib_1.__assign({}, state, { tenantSettings: null });
        case preferences.GET_TENANT_SETTINGS_SUCCESS:
            // Find quantity_picker setting
            var quantityPicker = 'relative';
            if (action.payload.find(function (setting) { return setting.key === 'quantity_picker'; })) {
                quantityPicker = action.payload.find(function (setting) { return setting.key === 'quantity_picker'; }).value;
            }
            var appName = 'Webshop';
            // Find appName
            if (action.payload.find(function (setting) { return setting.key === 'app_name'; })) {
                appName = action.payload.find(function (setting) { return setting.key === 'app_name'; }).value;
            }
            var tenantCode = null;
            // Find tenantCode
            if (action.payload.find(function (setting) { return setting.key === 'tenant'; })) {
                tenantCode = action.payload.find(function (setting) { return setting.key === 'tenant'; }).value;
            }
            // viewType
            var viewTypeAdjustable = true;
            var tenantViewType = 'grid-view';
            var viewType = state.viewType ? state.viewType : tenantViewType;
            var viewTypeSetting = action.payload.find(function (setting) { return setting.key === 'view_type'; });
            if (viewTypeSetting && viewTypeSetting.value) {
                viewTypeAdjustable = viewTypeSetting.value.viewTypeAdjustable;
                tenantViewType = viewTypeSetting.value.viewType;
            }
            if (!viewTypeAdjustable) {
                viewType = tenantViewType;
            }
            // Top menu style
            var topMenuStyle = null;
            if (action.payload.find(function (setting) { return setting.key === 'top_menu_style'; })) {
                topMenuStyle = action.payload.find(function (setting) { return setting.key === 'top_menu_style'; }).value;
            }
            // Catalog sort order
            var catalogSortOrders = null;
            if (action.payload.find(function (setting) { return setting.key === 'catalog_sort_orders'; })) {
                catalogSortOrders = action.payload.find(function (setting) { return setting.key === 'catalog_sort_orders'; }).value;
            }
            return tslib_1.__assign({}, state, { tenantViewType: tenantViewType, viewType: viewType, viewTypeAdjustable: viewTypeAdjustable, tenantSettings: action.payload, quantityPicker: quantityPicker, appName: appName, tenantCode: tenantCode, topMenuStyle: topMenuStyle, catalogSortOrders: catalogSortOrders });
        case preferences.GET_TENANT_SETTINGS_FAILED:
            return tslib_1.__assign({}, state, { error: action.payload });
        default:
            return state;
    }
}
export var getViewType = function (state) { return state.viewType; };
export var getViewTypeAdjustable = function (state) { return state.viewTypeAdjustable; };
export var isFullWidthViewEnabled = function (state) { return state.fullWidthView; };
export var getTenantSettings = function (state) { return state.tenantSettings; };
export var getQuantityPicker = function (state) { return state.quantityPicker; };
export var getAppName = function (state) { return state.appName; };
export var getTenantCode = function (state) { return state.tenantCode; };
export var getTopMenuStyle = function (state) { return state.topMenuStyle; };
export var getCatalogSortOrders = function (state) { return state.catalogSortOrders; };
